//
// Wire mirrors of Contracts/AI/DataModels/Insight/*.cs (camelCase). Everything but a sentence's
// text and a citation's own record data is a code, never a word: the client writes the labels for
// the action kinds and the reasons itself, the way it renders a track message.
//

export class InsightSentenceDTO {
  text: string | undefined;

  citationKeys: string[] | undefined;

  constructor() {
    this.text = undefined;
    this.citationKeys = [];
  }
}

export class InsightCitationDTO {
  key: string | undefined;

  kind: string | undefined;

  marker: number | undefined;

  isoControlId?: number;

  entityType?: number;

  entityId?: number;

  linkId?: number;

  version?: string;

  roomKey?: string;

  taskId?: number;

  value?: string;

  constructor() {
    this.key = undefined;
    this.kind = undefined;
    this.marker = undefined;
  }
}

export class InsightTargetDTO {
  entityType?: number;

  entityId?: number;

  roomKey?: string;

  taskId?: number;

  panel?: string;
}

export class InsightActionDTO {
  kind: string | undefined;

  primary: boolean | undefined;

  target?: InsightTargetDTO;

  reasonKey?: string;

  reasonValue?: string;

  constructor() {
    this.kind = undefined;
    this.primary = undefined;
  }
}

export class InsightDTO {
  source: string | undefined;

  failureReason?: string;

  sentences: InsightSentenceDTO[] | undefined;

  citations: InsightCitationDTO[] | undefined;

  actions: InsightActionDTO[] | undefined;

  generatedAt?: string;

  stateHash?: string;

  constructor() {
    this.source = undefined;
    this.sentences = [];
    this.citations = [];
    this.actions = [];
  }
}

/**
 * The Insight process row's `data` payload: what was asked for, and the answers composed so far for
 * this entity, keyed "{focus}:{lang}" so a second reader in another language does not evict the
 * first.
 */
export class TenantProcessStateInsightDTO {
  focus?: string;

  force?: boolean;

  insights?: Record<string, InsightDTO>;
}
